<mat-card class="sport-card" (click)="openTeamRoster()">
  <mat-card-header>
    <img mat-card-avatar *ngIf="team.sport?.icon" [src]="team.sport?.icon" (error)="commonService.imageErrorHandle($event)" class="header-image"/>
    <mat-card-title>{{team.gender}} - {{team.nickname}}</mat-card-title>
    <mat-card-subtitle>Total Members: {{team.totalPlayers}}</mat-card-subtitle>
  </mat-card-header>
</mat-card>
